var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Navigation"},[_c('button',{staticClass:"Navigation__burger-wrapper",class:[{ 'is-active': _vm.$route.meta.name != 'chapters' }],on:{"click":_vm.onClick}},[_c('span',{staticClass:"Navigation__burger"})])])}
var staticRenderFns = []

export { render, staticRenderFns }